<template>
  <div
    class="modal"
    :id="dialogId"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" :style="modalStyle">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h2 class="modal-title">
            <b v-html="errorText"></b>
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorDialog",
  props: {
    dialogId: {
      type: String,
      default: "ErrorDialog",
    },
    errorText: {
      type: String,
      default: "An Error has occurred",
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    colorOrange: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    modalStyle() {
      let bgColor = "red";
      let txtColor = "black";

      if (this.colorOrange) {
        bgColor = "orange";
      }

      return {
        "background-color": bgColor,
        "color": txtColor,
        "padding": "20px"
      }
    }
  },
  mounted() {
    $("#" + this.dialogId).on("hide.bs.modal", (e) =>
      this.$emit("closeDialog")
    );
    $("#" + this.dialogId).on("hidden.bs.modal", (e) =>
      this.$emit("dialogClosed")
    );
  },
  watch: {
    showDialog() {
      this.showDialog
        ? this.openDialog()
        : this.closeDialog();
    },
  },
  methods: {
    openDialog() {
      this.$nextTick(() => {
        $("#" + this.dialogId).modal("show");
      });
    },
    closeDialog() {
      $("#" + this.dialogId).modal("hide");
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ErrorDialog.vue?99e3262a